
// Can include HTML
const headline = `
  Flying during the coronavirus pandemic
`;

// Can include HTML
const subtitle = `
  Have you taken a flight recently? What was your experience and would you fly again soon? If you haven't returned to air travel, what will it take to get you on a flight?
`;

// keyURL is a shortcut for the generic submission link
const keyURL = 'travel-flying-pandemic';
const submissionURL = `https://submission.cnn.io/v3/forms/${keyURL}`;

// ./index.js has a check to make sure the date is valid
const expirationDate = new Date('2020-12-31');

export {
  headline,
  subtitle,
  submissionURL,
  expirationDate,
};
